(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.SurveyDetailsDialogController = (function(superClass) {
    extend(SurveyDetailsDialogController, superClass);

    function SurveyDetailsDialogController(scope, transitions, modalInstance, repo, survey_result, field) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.repo = repo;
      this.balanceColumns = bind(this.balanceColumns, this);
      this.loadSurveyDetails = bind(this.loadSurveyDetails, this);
      SurveyDetailsDialogController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.title = 'Survey Details';
      this.scope.placeholder = 'Loading survey details...';
      this.scope.left_column = {};
      this.scope.right_column = {};
      this.scope.isArray = function(value) {
        return value instanceof Array;
      };
      this.loadSurveyDetails(survey_result, field);
    }

    SurveyDetailsDialogController.prototype.loadSurveyDetails = function(survey_result, field) {
      return this.repo.getSurveyDetails(survey_result, field).then((function(_this) {
        return function(result) {
          var ref, ref1, ref2, ref3, results;
          if (((ref = result.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0) !== 'success') {
            if (((ref2 = result.data) != null ? ref2.status : void 0) != null) {
              _this.scope.setAlert((ref3 = result.data) != null ? ref3.status : void 0);
            } else {
              _this.scope.setAlert({
                type: 'error',
                msg: 'Failed to load details for this survey'
              });
            }
            return;
          }
          results = result.data.data.results;
          return _this.balanceColumns(results);
        };
      })(this), (function(_this) {
        return function() {
          return _this.scope.setAlert({
            type: 'error',
            msg: 'Failed to load details for this survey'
          });
        };
      })(this));
    };

    SurveyDetailsDialogController.prototype.balanceColumns = function(details) {
      var detail, i, is_array, j, key, left_height, len, len1, results1, total_height, value;
      this.scope.left_column = {};
      this.scope.right_column = {};
      if (!(details != null ? details.length : void 0)) {
        return;
      }
      total_height = 0;
      for (i = 0, len = details.length; i < len; i++) {
        detail = details[i];
        key = detail[0], value = detail[1];
        total_height += value instanceof Array ? 3 : 1;
      }
      left_height = 0;
      results1 = [];
      for (j = 0, len1 = details.length; j < len1; j++) {
        detail = details[j];
        key = detail[0], value = detail[1];
        is_array = value instanceof Array;
        if (!is_array && left_height < total_height / 2) {
          this.scope.left_column[key] = value;
          results1.push(left_height += 1);
        } else if (is_array && left_height < (total_height - 4) / 2) {
          this.scope.left_column[key] = value;
          results1.push(left_height += 3);
        } else {
          results1.push(this.scope.right_column[key] = value);
        }
      }
      return results1;
    };

    return SurveyDetailsDialogController;

  })(DialogController);

}).call(this);
